exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error {\n  font-size: large;\n  color: #f44336;\n  height: 20px;\n  border: solid;\n  margin: 7px;\n  text-align: center;\n  padding: 3px;\n}\n\n", ""]);

// exports
